<template>
    <span class="interval">
        <div class="interval-label main-text-color" v-if="label">
            {{ $t(label) }}
        </div>
        <el-time-picker
            class="interval-time-select"
            v-model="model"
            :disabled="disabled"
            clearable
            format="HH:mm"
            value-format="HH:mm"
            :picker-options="{
                format: 'HH:mm'
            }"
            placeholder="00:59"
            @change="onChange"
            default-value=""
        />
        <div class="el-form-item__error" v-show="isNotValidField && !isCondition">
          {{ $t('validation.error.fieldIsRequired') }}
        </div>
    </span>
</template>

<script>
import { TimePicker } from 'element-ui'

export default {
    components: {
        [TimePicker.name]: TimePicker, 
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: '' 
        },
        placeholder: {
            type: String,
            default: 'Time'
        },
        isRange: {
            type: Boolean,
            default: false
        },
        isClickedOnNextBtn: {
            type: Boolean,
            default: false
        },
        inputValue: {
            type: [Number, String]
        },
        isCondition: {
            type: Boolean,
            default: false
        },
        modelData: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        model (val) {
            this.$emit('input', val)
        }
    },
    data () {
        return {
            model: null
        }
    },
    mounted () {
        if (this.isCondition) {
            this.model = this.inputValue
        } else {
            const scheduleDataKey = 'ParameterTag' in this.$attrs ? this.$attrs.ParameterTag : this.$attrs.ComponentTag
            this.model = this.modelData[scheduleDataKey]
        }
    },
    computed: {
        isNotValidField () {
            return this.isClickedOnNextBtn && !this.model
        }
    },
    methods: {
        onChange (val) {
            const data = {
                value: val,
                component: this.$attrs
            }
            this.$emit('change', data)
        }
    }
};
</script>

<style lang="scss" scoped>
.interval-label {
    @apply mb-2;
}
[dir="rtl"] .interval-label {
    @apply ml-3;
}
[dir="ltr"] .interval-label {
    @apply mr-3;
}
.el-form-item__error {
    @apply pt-4;
}
.interval {
    @apply relative;
}
</style>

<style lang="scss">
.time-select .time-select-item.selected:not(.disabled) {
    @apply text-primary;
}
.time-select-item:hover {
    background: var(--mainBgColor-color);
}
.time-select-item {
    color: var(--mainTextColor-color);
    background: var(--secondaryBgColor-color);
}
</style>